import { styled } from 'styled-components'
import PS4 from '../../imgs/PS4-blanco.png'
import PS5 from '../../imgs/ps5-logo.png'
import pl from '../../imgs/pl.png'
import pl5 from '../../imgs/plps5.png'

const Container=styled.div`
width:100%;
height:100%;
box-sizing: border-box;


 `;


const Banner1=styled.div`
	background: rgb(0,81,179);
	background: linear-gradient(90deg, rgba(2,71,154,1) 0%, rgba(1,109,194,1) 46%, rgba(2,145,236,1) 100%);
	display:flex;
	align-items:center;
	justify-content: space-between;
	border:2px solid white;
	border-bottom-style:none;
	border-radius:5px 5px 0px 0px;
	height:5%;
	width:100%;
	box-sizing: border-box;

 `;

const Banner2=styled.div`
	height:5%;
	background-color:white;
	display:flex;
	align-items:center;
	justify-content: space-between;
	border:2px solid white;
	border-bottom-style:none;
	border-radius:5px 5px 0px 0px;
	justify-content: space-between;
	width:100%;
	box-sizing: border-box;

 `;

const ImgJuego=styled.div`
	border-top:2px solid white;
	height:95%;
	width:100%;
	background-position: center;
	background-size:cover;
	box-sizing: border-box;
 `;

const Consola=styled.img`
	height:80%;
	margin-left: 0.3em;
 `;

const Logo=styled.img`
	height:80%;
	margin-right: 0.5em;
 `;

export default function Card(props){
	let { consola,poster }=props;
	let banner=null;
	
	switch(consola){
	case "Playstation 4":
		banner=(
		<Banner1>
				<Consola src={PS4} />
				<Logo src={pl} />
		</Banner1>);
		break
	case  "Playstation 5":
		banner=(<Banner2>
					<Consola src={PS5} />
					<Logo src={pl5} />
				</Banner2>)
		break;
	default:
		banner=(<Banner2>
					<Consola src={PS5} />
					<Logo src={pl5} />
				</Banner2>)
	}


	return(
		<Container>
			
			{banner}
			<ImgJuego style={{backgroundImage:`url(${poster})`}} />
				
			
			
		</Container>
		)
} 